import { useEffect } from "react";
import { createPortal } from "react-dom";
import { useLocation } from "react-router-dom";
import { ErrorBoundary } from "@/react/components/shared/ErrorPages/ErrorBoundary";
import { useSmOrMdScreenMediaQuery } from "@/react/hooks/useMediaQuery";
import { usePunditUserContext } from "@circle-react/contexts";
import { useSpacesContext } from "@circle-react/contexts";
import { WIDGET_HIDDEN_ROUTES } from "../constants";
import { useHelpWidgetContext } from "../context/HelpWidgetContext";
import { clearHistory } from "../utils/locationHistoryManager";
import { HelpWidgetBody } from "./HelpWidgetBody";
import { HelpWidgetError } from "./HelpWidgetError";
import { HelpWidgetMobileBody } from "./HelpWidgetMobileBody";

interface HelpWidgetProps {
  showWidgetBot?: boolean;
}

export const HelpWidget = ({ showWidgetBot = false }: HelpWidgetProps) => {
  const location = useLocation();
  const { records: spaces } = useSpacesContext();
  const { currentCommunityMember } = usePunditUserContext();
  const shouldHideSupportWidget = !currentCommunityMember?.is_admin;

  const chatSpaces = spaces.filter(space => space.post_type === "chat");
  const chatSpacesSlugs = chatSpaces.map(space => space.slug);
  const routesWithWidgetHidden = [...WIDGET_HIDDEN_ROUTES, ...chatSpacesSlugs];

  const isWidgetHiddenOnRoute = routesWithWidgetHidden.some(route =>
    location.pathname.includes(route),
  );

  const { openWidget } = useHelpWidgetContext();
  const isMobile = useSmOrMdScreenMediaQuery();

  useEffect(() => {
    if (showWidgetBot) {
      clearHistory();
      openWidget();
    }
  }, []);

  if (shouldHideSupportWidget || isWidgetHiddenOnRoute) {
    return null;
  }

  return (
    <>
      {createPortal(
        <ErrorBoundary renderFunc={HelpWidgetError}>
          {isMobile ? <HelpWidgetMobileBody /> : <HelpWidgetBody />}
        </ErrorBoundary>,
        document.body,
      )}
    </>
  );
};
